(() => {
  if (window.__mhNewSale) return;
  window.__mhNewSale = true;

  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const parseMoney = (value) => {
    const text = String(value || '')
      .replace(/[٠-٩]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      .replace(/[۰-۹]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
      .replace(/٫/g, '.')
      .replace(/٬/g, ',');
    const matches = text.match(/\d[\d,]*(?:\.\d+)?/g);
    return matches ? Number(matches.at(-1).replace(/,/g, '')) : NaN;
  };
  const formatMoney = (value) => new Intl.NumberFormat(isArabic() ? 'ar-AE' : 'en-AE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);

  const updateCard = (card) => {
    if (!card) return;
    const price = card.querySelector('[data-price]');
    const compare = card.querySelector('[data-compare-price]');
    const media = card.querySelector('.ma-hawa-card__media');
    const priceBox = card.querySelector('.ma-hawa-card__price');
    if (!price || !compare || !media || !priceBox) return;

    let badge = media.querySelector('[data-mh-sale]');
    let saving = priceBox.querySelector('[data-mh-save]');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'ma-hawa-card__sale-badge';
      badge.dataset.mhSale = '';
      badge.innerHTML = '<span aria-hidden="true">✦</span><span></span>';
      media.append(badge);
    }
    if (!saving) {
      saving = document.createElement('span');
      saving.className = 'ma-hawa-card__sale-savings';
      saving.dataset.mhSave = '';
      priceBox.prepend(saving);
    }

    const current = parseMoney(price.textContent);
    const original = parseMoney(compare.textContent);
    const active = !compare.hidden && original > current && Number.isFinite(current) && Number.isFinite(original);
    card.classList.toggle('has-mahawa-sale', active);
    badge.hidden = !active;
    saving.hidden = !active;
    if (!active) return;

    const percent = Math.round(((original - current) * 100) / original);
    const amount = original - current;
    const badgeText = isArabic() ? `خصم ${percent}%` : `${percent}% OFF`;
    const savingText = isArabic() ? `وفّرت ${formatMoney(amount)} د.إ` : `You save AED ${formatMoney(amount)}`;
    badge.lastElementChild.textContent = badgeText;
    badge.setAttribute('aria-label', badgeText);
    saving.textContent = savingText;
  };

  const updateAll = (scope = document) => scope.querySelectorAll('.ma-hawa-card').forEach(updateCard);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateAll(), { once: true });
  else updateAll();
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variant-select]')) requestAnimationFrame(() => updateCard(event.target.closest('.ma-hawa-card')));
  });
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
})();
